"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _MarginRepayLoanFormComponent = _interopRequireDefault(require("./MarginRepayLoanFormComponent"));
var _productsSelectors = require("../../../lib/redux/selectors/productsSelectors");
var _marginHistoryActions = require("../../../lib/redux/margin/actions/marginHistoryActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var _state$form$MARGIN_RE;
  var position = _ref.position;
  var repaymentAssetOptions = state.margin.history.repaymentAssetOptions;
  var formValues = ((_state$form$MARGIN_RE = state.form[MARGIN_REPAY_LOAN_FORM]) === null || _state$form$MARGIN_RE === void 0 ? void 0 : _state$form$MARGIN_RE.values) || [];
  var repaymentAmount = (formValues === null || formValues === void 0 ? void 0 : formValues.repaymentAmount) || 0;
  var sliderValue = (Math.min(Number(repaymentAmount) / position.BorrowedAmount, 1) * 100).toFixed(0);
  var decimalPlaces = (0, _productsSelectors.decimalsByProductId)(state);
  var modifiedRepaymentAssetOptions = repaymentAssetOptions.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      id: item.ProductId,
      DecimalPlaces: decimalPlaces[item.ProductId] || 8,
      checked: true
    });
  });
  return {
    notionalProduct: (0, _productsSelectors.baseNotionalProductSelector)(state),
    repaymentAssetOptions: modifiedRepaymentAssetOptions,
    sliderValue: sliderValue,
    repaymentAmount: repaymentAmount
  };
};
var MARGIN_REPAY_LOAN_FORM = 'marginRepayLoan';
var Form = (0, _reduxForm.reduxForm)({
  form: MARGIN_REPAY_LOAN_FORM,
  onSubmit: function onSubmit() {}
})(_MarginRepayLoanFormComponent["default"]);
var MarginTransferAssetsFormContainer = (0, _reactRedux.connect)(mapStateToProps, {
  reduxFormChange: function reduxFormChange(key, val) {
    return (0, _reduxForm.change)(MARGIN_REPAY_LOAN_FORM, key, val);
  },
  repayMarginPosition: _marginHistoryActions.repayMarginPosition
})(Form);
MarginTransferAssetsFormContainer.propTypes = {
  position: _propTypes["default"].object,
  closeModal: _propTypes["default"].func,
  isOpen: _propTypes["default"].bool
};
var _default = exports["default"] = MarginTransferAssetsFormContainer;